<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="5">
        <px-situacao-compra-icon :situacao="venda.situacao"/>
        {{ venda.comprador.pessoa.nome }}
        <div class="caption">
          {{ venda.comprador.pessoa.cnpj | cnpj }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <div class="pt-2">
          {{ venda.produtos.length }} produto(s)
        </div>
      </v-col>
      <v-col cols="12" sm="2">
        <div class="pt-2">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ venda.total | currency }}
            </span>
            </template>
            <span>Total da compra</span>
          </v-tooltip>
        </div>
      </v-col>
      <v-col cols="12" sm="2">
        <template v-if="!isFinalizada">
          <px-venda-conjunta-aprovar-pedido :venda="venda" @update="onUpdate"/>
          <px-finalizacao-recusar-dialog :compra="venda" :compra-id="venda.id"
                                         @movimentar="onUpdate">
            <template v-slot:activator="{ on }">
              <v-tooltip top>
                <template v-slot:activator="{ on: onTooltip }">
                  <v-btn icon v-on="{ ...onTooltip, ...on }">
                    <v-icon>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </template>
                <span>Recusar pedido</span>
              </v-tooltip>
            </template>
          </px-finalizacao-recusar-dialog>
        </template>
        <v-btn icon link :to="`/venda/${venda.id}`" @click.stop="">
          <v-icon>
            mdi-eye
          </v-icon>
        </v-btn>
        <template v-if="isAprovada">
          <px-avaliacao-dialog v-if="!venda.avaliacao"
                               :compra-id="venda.id"
                               :disabled="!isAprovada"
                               :name="venda.comprador.pessoa.nome"
                               title="Avaliação de venda"
                               text="Como você avalia a venda para a empresa"
                               tipo-avaliacao="COMPRADOR"
                               @update="onUpdate"/>
          <px-show-avaliacao-menu v-if="venda.avaliacao"
                                  title="Avaliação da venda"
                                  :avaliacao="venda.avaliacao.avaliacao"/>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { SituacaoCompra } from 'px-business-components';
import FinalizacaoRecusarDialog from '@/modules/vendas/finalizacao/FinalizacaoRecusarDialog.vue';
import VendaConjuntaAprovarPedido from './VendaConjuntaAprovarPedido.vue';

const FINALIZADAS = [
  SituacaoCompra.keys.APROVADA.key,
  SituacaoCompra.keys.RECUSADA.key,
  SituacaoCompra.keys.CANCELADA.key,
];

export default {
  props: {
    venda: Object,
  },
  computed: {
    isFinalizada() {
      return FINALIZADAS.includes(this.venda.situacao);
    },
    isAprovada() {
      return SituacaoCompra.keys.APROVADA.key === this.venda.situacao;
    },
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxVendaConjuntaAprovarPedido: VendaConjuntaAprovarPedido,
    pxFinalizacaoRecusarDialog: FinalizacaoRecusarDialog,
  },
};
</script>
